import { useParams } from "react-router-dom";

import EntityInfo from "../../../../../components/modules/providers/provider-management/components/management/EntityInfo";
import Navigation from "../../../../../components/navigations/provider-management/detail/management/navigation";

export default function Template() {
  const { id } = useParams();

  return (
    <Navigation activeTab="entity-info" providerId={id}>
      <EntityInfo />
    </Navigation>
  );
}
